import { IApplicationData } from "./common";

export class Transcribe implements IApplicationData {
  constructor() {
    this.name = "Transcribe";
    this.input = "";
    this.language = "en-US";
    this.transcriptionVariable = "";
    this.isConversation = false;
    this.speakerList = '["Speaker 1","Speaker 2"]';
    this.format = "raw";
    this.languageOption = "listLang";
    this.languageAttribute = "";
    this.transition = true;
    this.isRequired = true;
    this.checkFields = false;
  }

  name: string;
  input: string;
  language: string;
  transcriptionVariable: string;
  isConversation: boolean;
  speakerList: string;
  format: string;
  languageAttribute: string;
  transition: boolean;
  isRequired: boolean;
  checkFields: boolean;
  languageOption: string;
}
